import remotePatterns from '../../public/remote-patterns.json';

/**
 * TODO: Change this file to use the remote configuration
 * @see https://gist.github.com/jihchi/bbc718366fbb6342e0a48045f18c82e5
 * Be careful on not leak non public values to the client
 */

export const dynamic = 'force-dynamic';

const fullConfig = {
  host: process.env.NEXT_PUBLIC_HOST || 'https://peoople.app',
  api: process.env.NEXT_PUBLIC_API || 'https://api.peoople.app',
  graphql: process.env.NEXT_PUBLIC_GRAPHQL_API || 'https://api-graphql.peoople.app/graphql',
  map: {
    key: 'AIzaSyA5MHp-p6KoAaAiWHK1H3K0BANIXgQNYRM',
  },
  gtm: process.env.NEXT_PUBLIC_GTM_ID || 'GTM-KF7LB5HC',
  images: {
    remotePatterns,
  },
  gfk: {
    media: process.env.NEXT_PUBLIC_GFK_MEDIA || 'PeoopleWeb',
    // TODO: After GFK validate the implementation, add env NEXT_PUBLIC_GFK_HOST with //es-config.sensic.net/s2s-web.js
    // to the cluster
    url: process.env.NEXT_PUBLIC_GFK_HOST || '//es-config-preproduction.sensic.net/s2s-web.js',
  },
  server: {
    apikey: process.env.API_KEY,
    oauth: {
      google: {
        id: process.env.GOOGLE_CLIENT_ID,
        secret: process.env.GOOGLE_CLIENT_SECRET,
      },
      facebook: {
        id: process.env.FB_CLIENT_ID,
        secret: process.env.FB_CLIENT_SECRET,
      },
    },
    hermes: {
      key: process.env.HERMES_KEY || '',
    },
    cache: {
      host: process.env.CACHE_HOST || 'localhost',
      port: process.env.CACHE_PORT || '6379',
      mode: process.env.CACHE_MODE,
      hosts: (process.env.CACHE_HOSTS || '').split(','),
    },
  },
};

const getClientConfig = () => {
  const { content }: any = document.head.querySelector('[name="peoople:config"]') || {};
  if (content) {
    return JSON.parse(content);
  }
  const { server, ...conf } = fullConfig;
  return conf;
};

const configuration = typeof window !== 'undefined' ? getClientConfig() : fullConfig;

export default configuration as typeof fullConfig;
